import React from "react";
import styled from "styled-components";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import TextField from "@mui/material/TextField";

const ButtonComment = styled.button`
  min-width: 80px;
  min-height: 40px;
  background-color: white;
  border: none;
  cursor: pointer;
  &:disabled {
    color:#000000;
    cursor:auto;
  }
`;

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function CustomCommentDialog(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <ButtonComment onClick={handleClickOpen} disabled={props.disabled}>{props.comment}</ButtonComment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Commentaire
        </DialogTitle>
        <TextField
          autoFocus
          margin="dense"
          id="outlined-multiline-static"
          label="Commentaire"
          multiline
          rows={4}
          defaultValue={props.comment}
          onChange={props.handleNewComment}
          variant="outlined"
          style={{ width: "96%", marginLeft: "2%" }}
        />
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Annuler
          </Button>
          <Button
            onClick={() => {
              props.handleSendComment();
              handleClose();
            }}
            color="success"
          >
            {" "}
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
